var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Delete as IconDelete } from "@mui/icons-material";
import { FormHelperText, IconButton, InputAdornment, TextField, } from "@mui/material";
import { reduceBreakLines } from "@smp/utils";
import { forwardRef, useCallback, useRef, useState, } from "react";
import { useUnmount, useUpdateEffect } from "react-use";
import { ContentEditableDiv } from "./components/content_editable_div";
const getValidNumberValue = (target) => {
    const isNumber = target instanceof HTMLDivElement
        ? target.getAttribute("type") === "number"
        : target.type === "number";
    const value = target instanceof HTMLDivElement
        ? reduceBreakLines(target.innerText)
        : target.value;
    console.log("getValidNumberValue", value);
    if (!isNumber) {
        return value;
    }
    const valueNumber = Number(value);
    const min = Number(target.getAttribute("min") || -Infinity);
    const max = Number(target.getAttribute("max") || Infinity);
    if (valueNumber < min || valueNumber > max) {
        return String(valueNumber < min ? min : max);
    }
    if (value === "" && min !== undefined) {
        return String(min);
    }
    return value.toString();
};
export const UiTextFieldV2 = forwardRef((_a, ref) => {
    var _b, _c, _d;
    var { errorMessage, onDelete, onChange, onChangeContent, onBlur, value, debounce, validationEnabled, contentEditable } = _a, props = __rest(_a, ["errorMessage", "onDelete", "onChange", "onChangeContent", "onBlur", "value", "debounce", "validationEnabled", "contentEditable"]);
    const [selfValue, setSelfValue] = useState(value);
    const debounceId = useRef(0);
    const handleChange = useCallback((e) => {
        const value = e.target instanceof HTMLDivElement
            ? reduceBreakLines(e.target.innerText)
            : e.target.value;
        setSelfValue(value);
        window.clearTimeout(debounceId.current);
        debounceId.current = window.setTimeout(() => {
            if (onChange &&
                (!validationEnabled ||
                    Number(getValidNumberValue(e.target)) === Number(value))) {
                !contentEditable
                    ? onChange(e)
                    : onChangeContent === null || onChangeContent === void 0 ? void 0 : onChangeContent(value);
            }
        }, debounce || 0);
    }, [contentEditable, debounce, onChange, onChangeContent, validationEnabled]);
    const handleBlur = useCallback((e) => {
        var _a;
        if (validationEnabled) {
            const validValue = getValidNumberValue(e.target);
            if (e.target.value !== validValue) {
                const nativeInputValueSetter = (_a = Object === null || Object === void 0 ? void 0 : Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) === null || _a === void 0 ? void 0 : _a.set;
                if (nativeInputValueSetter) {
                    const event = new Event("change", { bubbles: true });
                    nativeInputValueSetter.call(e.target, validValue);
                    e.target.dispatchEvent(event);
                }
            }
        }
        onBlur && onBlur(e);
    }, [onBlur, validationEnabled]);
    useUpdateEffect(() => {
        setSelfValue(value);
    }, [value]);
    useUnmount(() => {
        window.clearTimeout(debounceId.current);
    });
    const endAdornment = onDelete ? (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { onClick: onDelete, size: "small", children: _jsx(IconDelete, { fontSize: "small" }) }) })) : undefined;
    return (_jsxs(_Fragment, { children: [_jsx(TextField, Object.assign({ ref: ref, value: selfValue, onChange: handleChange, onBlur: handleBlur }, props, { InputProps: Object.assign({ endAdornment: endAdornment || ((_b = props.InputProps) === null || _b === void 0 ? void 0 : _b.endAdornment), inputComponent: ((_c = props.InputProps) === null || _c === void 0 ? void 0 : _c.inputComponent)
                        ? (_d = props.InputProps) === null || _d === void 0 ? void 0 : _d.inputComponent
                        : contentEditable
                            ? ContentEditableDiv
                            : undefined }, props.InputProps) })), !!errorMessage && _jsx(FormHelperText, { children: errorMessage })] }));
});
//# sourceMappingURL=ui_text_field_v2.js.map